export default __webpack_public_path__ + "static/media/minimun.e13fdb72.png";